import React from 'react';
import { Box } from '@mui/material';
import { formCardShadow } from '../styles/uiTokens';

const FormCard = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        mt: 3,
        p: { xs: 2, sm: 3, md: 4 },
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: formCardShadow,
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default FormCard;
